import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { MultiStyleType } from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

export const enum TransferHeaderVariants {
  Default = 'default',
  Disabled = 'disabled',
}

const transferHeaderParts = [
  'container',
  'input',
  'inputRightElement',
  'iconButton',
  'icon',
] as const

const helpers = createMultiStyleConfigHelpers(transferHeaderParts)

export const TransferHeaderStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      paddingBottom: '20px',
    },
    input: {
      height: '60px',
      backgroundColor: 'transparent',
      borderColor: 'border.muted',
      color: 'fg.default',
      _placeholder: {
        color: 'fg.muted',
      },
    },
    inputRightElement: {
      paddingTop: '18px',
      paddingRight: '20px',
      gap: '4px',
    },
    iconButton: {
      borderRadius: 'full',
      background: 'blue.solid',
      _hover: {
        background: 'blue.solid',
      },
      _active: {
        background: 'blue.solid',
      },
      transition: 'opacity 0.2s ease-out',
    },
    icon: {
      color: 'fg.inverted',
      boxSize: '24px',
    },
  },
  variants: {
    [TransferHeaderVariants.Default]: {
      iconButton: {
        opacity: '1',
        _hover: {
          cursor: 'pointer',
        },
      },
    },
    [TransferHeaderVariants.Disabled]: {
      iconButton: {
        opacity: '0',
        _hover: {
          cursor: 'default',
        },
      },
    },
  },
  defaultProps: {
    variant: TransferHeaderVariants.Default,
  },
})

export const useTransferHeaderStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(TransferHeaderStyle, props) as MultiStyleType<
    typeof transferHeaderParts
  >
}
